module.exports = __webpack_public_path__ + "images/file_icons_v2/db-d9b6ee9741a33ddad571b410c17800fc.svg";